import { graphql } from "@/lib/gql/__generated__/gql";

export const VoucherIssuedForCampaignListByHotelIDAndVoucherID_DetailsPage_Query = graphql(`
	query VoucherIssuedForCampaignListByHotelIDAndVoucherID_DetailsPage($hotelID: ID!, $voucherID: ID!) {
		voucherIssuedForCampaignListByHotelIDAndVoucherID(hotelID: $hotelID, voucherID: $voucherID) {
			id
			voucherIssuedForCampaignList {
				hotelID
				voucherCode
				userECReceiptID
				usedReservationID
				useableStartDt
				cinStart
				cinEnd
				guestName
				guestEmail
				guestPostalCode
				guestAddress
				guestTel
				sendingMethod
				resourceAvailablePrice {
					currencyType
					amount
				}
				createdAt
				createdDt
				usedAt
			}
		}
		voucherForCampaign(hotelID: $hotelID, voucherID: $voucherID) {
			hotelID
			voucherID
			inSale
			name
			description
			mainKeyVisual {
				bucket
				key
				region
				mimeType
				fileName
			}
			voucherPrice {
				currencyType
				amount
			}
			resourceAvailablePrice {
				currencyType
				amount
			}
			voucherGiftList {
				guestName
				guestTel
				guestEmail
			}
			voucherExplanationForHost
			mailTemplate
			cinStart
			cinEnd
			createdAt
			deletedAt
		}
	}
`);
